import { cloud, billingRequest } from './lib/climbwriterCloud';
const button=document.querySelector<HTMLAnchorElement>('#plus-trial')!;
const details=document.querySelector<HTMLElement>('#plus-trial-details')!;
const message=document.querySelector<HTMLElement>('#pricing-checkout-message')!;
let busy=false;
const goToAccount=()=>window.location.assign('/?account=plan&trial=14');
const status=async()=>{
  const {data,error}=await cloud!.auth.getUser();
  if(error||!data.user) return null;
  return billingRequest('status');
};
function showPlan(result:Awaited<ReturnType<typeof billingRequest>>|null) {
  if(!result)return;
  if(result.isAdmin||['active','trialing'].includes(result.subscriptionStatus??'')) {
    button.textContent='Manage Plus';details.textContent=result.isAdmin?'Your admin account includes Plus.':'Your Plus access is already active.';
  } else if(!result.trialEligible) {
    button.textContent='Get Plus · $6.99/month';details.textContent='Your free trial has already been used. Manage your plan in Account.';
  }
}
if(cloud) void status().then(showPlan).catch(()=>{});
button.addEventListener('click',event=>{
  event.preventDefault();if(busy)return;
  busy=true;button.setAttribute('aria-disabled','true');message.textContent='Opening your free trial…';
  void(async()=>{
    try {
      if(!cloud){goToAccount();return;}
      const result=await status();
      if(!result){localStorage.setItem('climbwriter-trial-intent','14');goToAccount();return;}
      if(result.isAdmin||['active','trialing'].includes(result.subscriptionStatus??'')||!result.trialEligible){window.location.assign('/?account=plan');return;}
      const checkout=await billingRequest('checkout','monthly',true);
      const url=new URL(checkout.url??'');
      if(url.protocol!=='https:'||!['checkout.stripe.com','billing.stripe.com'].includes(url.hostname))throw new Error('Checkout could not be opened. Please try again.');
      window.location.assign(url.href);
    } catch(error) {message.textContent=error instanceof Error?error.message:'Checkout could not be opened. Please try again.';busy=false;button.removeAttribute('aria-disabled');}
  })();
});
// Click also exposes the explanation on touchscreens; hover and keyboard focus use CSS.
document.querySelectorAll<HTMLButtonElement>('.pricing-feature-trigger').forEach(trigger=>trigger.addEventListener('click',()=>{
  const feature=trigger.closest('.pricing-feature')!;
  document.querySelectorAll('.pricing-feature.is-open').forEach(other=>{if(other!==feature)other.classList.remove('is-open');});
  if(!feature.classList.toggle('is-open'))trigger.blur();
}));
document.addEventListener('click',event=>{if(!(event.target instanceof Element)||event.target.closest('.pricing-feature'))return;document.querySelectorAll('.pricing-feature.is-open').forEach(feature=>feature.classList.remove('is-open'));});
